export default "__VITE_ASSET__daae50c2__"